var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_2186",
  "data-name": "Group 2186",
  transform: "translate(-707 355)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_294",
  "data-name": "Rectangle 294",
  width: 24,
  height: 24,
  rx: 12,
  transform: "translate(707 -355)",
  fill: "#c7c7c7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_30",
  "data-name": "Path 30",
  d: "M65.271,12.4a9.623,9.623,0,0,1-1.685-2.332,5.183,5.183,0,0,1-.32-3.043A6.5,6.5,0,0,1,64.6,4.208a2.676,2.676,0,0,0,.7,1.99,4.66,4.66,0,0,1,1.1-3.924A8.322,8.322,0,0,1,69.948,0a2.756,2.756,0,0,0-.494,2.673A11.055,11.055,0,0,0,70.762,5.2a5.575,5.575,0,0,1,.988,2.616,9.059,9.059,0,0,0,.726-1.507,2.918,2.918,0,0,0,.116-1.649,4.189,4.189,0,0,1,.959,2.047,8.423,8.423,0,0,1,.029,2.417,5.957,5.957,0,0,1-.842,2.531,4.843,4.843,0,0,1-2.528,1.848A5.84,5.84,0,0,1,65.271,12.4Z",
  transform: "translate(650.832 -349.629)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_30-2",
  "data-name": "Path 30",
  d: "M64.838,9.847A7.643,7.643,0,0,1,63.5,7.995a4.116,4.116,0,0,1-.254-2.416,5.163,5.163,0,0,1,1.061-2.236,2.126,2.126,0,0,0,.554,1.581,3.7,3.7,0,0,1,.877-3.117A6.609,6.609,0,0,1,68.553,0a2.189,2.189,0,0,0-.392,2.123A8.78,8.78,0,0,0,69.2,4.133a4.427,4.427,0,0,1,.785,2.078,7.192,7.192,0,0,0,.577-1.2,2.317,2.317,0,0,0,.092-1.31,3.327,3.327,0,0,1,.761,1.626,6.691,6.691,0,0,1,.023,1.92,4.731,4.731,0,0,1-.669,2.01,3.847,3.847,0,0,1-2.007,1.468A4.638,4.638,0,0,1,64.838,9.847Z",
  transform: "translate(651.665 -347.657)",
  fill: "#c7c7c7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31",
  "data-name": "Path 31",
  d: "M152.321,222.526c1.689.834,3.357-1.693,2.43-3.647,0-.026-.021-.026-.021-.052a3.109,3.109,0,0,1-.515,2.292,3.005,3.005,0,0,0-.185-1.98c-.247-.6-.6-1.146-.865-1.719a3.366,3.366,0,0,1-.35-1.954,3.616,3.616,0,0,0-.989,1.928,4.333,4.333,0,0,0,.206,2.292,1.856,1.856,0,0,1-.556-1.25,3.14,3.14,0,0,0-.515,1.8A2.659,2.659,0,0,0,152.321,222.526Z",
  transform: "translate(566.017 -559.524)",
  fill: "#fff"
}))));
export default __webpack_public_path__ + "static/media/hotselling-inactive.a9d6e466.svg";
export { SvgComponent as ReactComponent };